import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';

import queryClient from '@App/app.query-client';

import { copyCompanyMobilityOffer, deleteCompanyMobilityOffer } from './company.service';

function useClearMobilityOfferMutation(companyId, onSuccess) {
  return useMutation({
    mutationFn: () => deleteCompanyMobilityOffer(companyId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['user', 'companies'] });
      toast.success('Jouw aanpassingen zijn opgeslagen');
      onSuccess();
    },
    onError: () => {
      toast.error('Er ging helaas iets mis bij het leegmaken');
    },
  });
}

function useCopyMobilityOfferMutation(toCompanyId, fromCompanyId, onSuccess) {
  return useMutation({
    mutationFn: () => copyCompanyMobilityOffer(toCompanyId, fromCompanyId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['user', 'companies'] });
      toast.success('Mobiliteitsplan is gekopieerd');
      onSuccess();
    },
    onError: () => {
      toast.error('Er ging helaas iets mis bij het kopieren');
    },
  });
}

export {
  useClearMobilityOfferMutation,
  useCopyMobilityOfferMutation,
};
